export default __webpack_public_path__ + "static/media/googleplay-badge.6f026a0a.png";